import classes from './login-stage-two.module.scss';

import {
  Card,
  CardHeader,
  CardActions,
  CardContent,
  Divider,
  Link,
  FormControlLabel,
  Checkbox,
} from '@mui/material';

import {
  CcfTypography,
  CcfBox,
  CcfButton,
  useTranslator,
  CcfTextField,
} from '@nice-ccf/ui-controls';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

import {
  CcfCheckBoxIcon,
  CcfCheckBoxOutlineBlankIcon,
} from '@nice-ccf/ui-controls';
import { useMsal } from '@azure/msal-react';

export interface LoginStageTwoProps {
  navigateToUsernameLoginScreen: () => void;
  currentpassword: string;
  currentusername: string;
  onPasswordChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error: {
    message: string;
    status: boolean;
  };
  checkUserNameAndPassword: (e: React.FormEvent<HTMLFormElement>) => void;
}

/**
 * Component for login stage two (check password and navigate)
 * @param props - LoginStageOneProps
 * @example <LoginStageOne />
 * @returns
 */
export function LoginStageTwo(props: LoginStageTwoProps) {
  const {
    navigateToUsernameLoginScreen,
    currentusername,
    currentpassword,
    onPasswordChange,
    checkUserNameAndPassword,
    error,
  } = props;
  const [translate] = useTranslator();
  const signInHeader = translate('signInHeader');
  const password = translate('password');
  const rememberMe = translate('rememberMe');

  return (
    <Card className={classes.stageTwoCard}>
      <CardHeader
        title={signInHeader}
        classes={{ title: classes.title }}
        className={classes.header}
      />
      <Divider />
      <form onSubmit={checkUserNameAndPassword}>
        <CardContent className={classes.content}>
          <CcfBox display="flex" alignItems="center" my={2}>
            <AccountCircleIcon
              fontSize="large"
              style={{ color: 'rgba(0, 0, 0, 0.26)' }}
            />
            <CcfTypography variant="subtitle1">
              <CcfBox
                ml={1}
                fontWeight={600}
                style={{ wordBreak: 'break-word', textAlign: 'left' }}
              >
                {currentusername}
              </CcfBox>
            </CcfTypography>
          </CcfBox>
          <CcfTextField
            id="password"
            placeholder={password}
            type="password"
            size="small"
            variant="outlined"
            fullWidth={true}
            value={currentpassword}
            onChange={onPasswordChange}
            helperText={error.status && error.message}
            error={error.status}
            autoFocus
          />
        </CardContent>
        <CardActions className={classes.actions}>
          <CcfBox width="100%" border={1} color="primary.main">
            <CcfButton
              variant="text"
              className={classes.secondaryButtonStyling}
              fullWidth={true}
              color="inherit"
              size="medium"
              classes={{ startIcon: classes.backButtonIcon }}
              startIcon={
                <ArrowBackIosIcon color="primary" fontSize="inherit" />
              }
              onClick={navigateToUsernameLoginScreen}
            >
              <CcfTypography translationKey="backButtonText" />
            </CcfButton>
          </CcfBox>
          <CcfButton
            type="submit"
            variant="contained"
            color="primary"
            disabled={currentpassword.length > 0 ? false : true}
            fullWidth={true}
            className={
              currentpassword.length === 0
                ? classes.primaryButtonDisabledStyle
                : classes.primaryButtonStyling
            }
          >
            <CcfTypography translationKey="signInButtonText" />
          </CcfButton>
        </CardActions>
      </form>
      <CcfBox
        px={2}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        <div className={classes.rememberMePlaceHolder}>
          <FormControlLabel
            value="Remember Me"
            control={
              <Checkbox
                color="primary"
                className={classes.rememberMeCheckBox}
                icon={<CcfCheckBoxOutlineBlankIcon />}
                checkedIcon={<CcfCheckBoxIcon />}
              />
            }
            label={rememberMe}
            labelPlacement="end"
          />
        </div>
        <Link className={classes.linkCursor}>
          <CcfTypography translationKey="loginStageTwoForgotPassword" />
        </Link>
      </CcfBox>
    </Card>
  );
}

export default LoginStageTwo;
